var option_default = {
  "option": "Fzpje",
  "user_choice": "_38gbf",
  "check": "mwJp8",
  "image": "Q0qvP",
  "input": "tFLoz",
  "title": "j0d4G",
  "centered": "EbIam",
  "with_result": "RjeGM",
  "list": "hJHkM",
  "with_image": "PBESm",
  "progress": "-UdZy",
  "progress_value": "n3zvB",
  "label": "qnR8x",
  "cta": "fVI8d",
  "adornment_icon": "Gtw5S",
  "remove": "XKklS",
  "removeButton": "j3N3X",
  "removeButtonIcon": "cyv1o",
  "overlay": "S6iaz",
  "shown": "AWi7o",
  "dark": "qE8QD",
  "spinner": "j6uq-",
  "spin": "n93MY"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
